// src/components/AppComponents/Sidebar/UserProfile.tsx

import { useUserSettingsStore } from '@/domains/user/userSettings.store';
import { useUserProfileStore } from '@/domains/user/userProfile.store';
import { useUserProfileUseCase } from '@/domains/user/user.usecases';

import DropdownUserProfile from './DropdownUserProfile';

import { Button } from '@UI/components/Button';
import { Loader } from '@UI/components/Loader/loader';
import { Icon } from '@UI/components/Icon';
import { RiExpandUpDownLine, RiUser3Line } from '@remixicon/react';
import i18n from '@/shared/i18n/i18n';

const UserProfile: React.FC = () => {
  const isCollapsed = useUserSettingsStore(
    (state) => state.settings.menu_collapsed,
  );
  const { isLoading, isError } = useUserProfileUseCase();
  const { user } = useUserProfileStore();
  if (isError && !user) {
    return <p>{i18n.t('errors.unknown')}</p>;
  }
  return (
    <Loader
      loading={isLoading}
      size="xs"
      className="bg-revving-background-muted dark:bg-darkRevving-background-muted"
    >
      {user && (
        <DropdownUserProfile user={user}>
          <Button
            icon={RiUser3Line}
            variant="secondary"
            className="w-full justify-start border-0 !shadow-none menuButton max-lg:pr-1.5"
          >
            {!isCollapsed && (
              <span className="hidden lg:flex justify-between items-center w-[calc(var(--expanded-sidebar-width)-3.5rem)]">
                <span className="truncate">
                  {`${user.first_name} ${user.last_name}`}
                </span>
                <Icon icon={RiExpandUpDownLine} size="md" />
              </span>
            )}
          </Button>
        </DropdownUserProfile>
      )}
    </Loader>
  );
};

export default UserProfile;
